import styled from "styled-components";

export const DailySettlementSummaryRevenueDepositWrapper = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  width: 600px;
`;

export const DailySettlementSummaryRevenueDeposit = styled.div`
  height: 37px;
  display: flex;
  align-items: center;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 19px;
  gap: 12px;
  width: 165px;
  color: #121212;

  > span {
    font-weight: 600;
    font-size: 15px;
    color: #808080;
    text-align: right;
    flex: 1;
    padding-right: 16px;

    &.weight {
      padding-right: 0;
      font-weight: 600;
      font-size: 19px;
      color: #121212;
    }
  }
`;
